import React from "react";
import { Warning } from "@material-ui/icons";

export default function ModalConfirm({
  title,
  message,
  onConfirm,
  onClose,
  icon: Icon = Warning,
  iconColor = "#f42a3f",
  backgroundColor = "#FBEAEC",
  oneButtonMessage,
  confirmButtonMessage = "Confirmar",
  cancelButtonMessage = "Cancelar",
  isLoading = false,
  children,
}) {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999
      }}
      
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "8px",
          padding: "32px",
          minWidth: "320px",
          boxShadow: "0 2px 16px rgba(0,0,0,0.2)",
          textAlign: "center"
        }}
      >
        <Icon
          style={{
            color: iconColor,
            fontSize: 64,
            marginBottom: 16,
            background: backgroundColor,
            borderRadius: "8px"
          }}
        />
        <h2>{title}</h2>
        <p>{message}</p>
        {children}
        <div
          style={{
            marginTop: 24,
            display: "flex",
            justifyContent: "center",
            gap: 16
          }}
        >
          {oneButtonMessage ? (
            <button
              className="btn btn-primary w-100"
              onClick={handleCloseModal}
            >
              {oneButtonMessage}
            </button>
          ) : (
            <>
              <button
                className="btn btn-outline-primary w-100"
                onClick={handleCloseModal}
                disabled={isLoading}
              >
                {cancelButtonMessage}
              </button>
              <button
                className="btn btn-primary w-100"
                onClick={handleConfirm}
                disabled={isLoading}
              >
                {confirmButtonMessage}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
